//PrintAddressChangeUI.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as GraLay from "../Util/GraLay";
import * as MainMap from "../MainMap";
import * as PrintAddressChangeMap from "./PrintAddressChangeMap";
import * as Settings from "../Settings";
import * as SnackBar from "../Util/SnackBar";
import * as Util from "../Util/Util";
import * as Util_MUI from "../Util/Util_MUI";
import * as WidgetHeading from "../Widgets/WidgetHeading";

import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

import {
   Button, Checkbox, FormControl, FormControlLabel, FormLabel, FormGroup, Icon, IconProps,
   Link, Paper, Radio, TextField, Typography
} from "@mui/material";

import React from "react";

const toolName: string = "Print Address Change";

export let scaleText: string;
export let mapScaleFeetPerInch: number;
export let isStandardScale = false;

export let printToolActivated: boolean;
export let ownerText: string;
export let ownerAddressText: string;
export let approvalDateText: string;
export let oldStreetText: string;
export let newStreetText: string;
export let thomasBrothersText: string;
export let mapNoText: string;
export let projectNoText: string;
export let apnText: string;
/*export let newWindow: Window;*/

let drag_handle: __esri.Handle;
let stationary_handle: __esri.Handle;

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   Util.logMsg("Top of Print Address Change.Render");

   //Initialize.
   if (typeof scaleText === "undefined") {
      scaleText = Settings.print.scales[0];
   }

   setStandardScale();

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Component did mount.
   React.useEffect(() => {
      drag_handle = MainMap.activeView.on("drag", function () {
         if (DrawerMenu.curToolName === "Print Address Change") {
            PrintAddressChangeMap.setPrintParameters(false);
         }
      });

      stationary_handle = reactiveUtils.when(() => MainMap.activeView?.stationary === true, function () {
         if (DrawerMenu.curToolName === "Print Address Change") {
            if (isStandardScale) {
               PrintAddressChangeMap.setPrintParameters();
            } else {
               PrintAddressChangeMap.setPrintParameters(false);
            }
         }
      });

      let resizeTimeout: NodeJS.Timeout;

      window.addEventListener('resize', function () {
         if (DrawerMenu.curToolName === "Print Address Change") {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
               if (isStandardScale) {
                  PrintAddressChangeMap.setPrintParameters();
               } else {
                  PrintAddressChangeMap.setPrintParameters(false);
               }
            }, 800); // Delay ms after resizing ends.
         }
      }, { passive: true });

      PrintAddressChangeMap.setPrintParameters();

      //Component will unmount.
      return () => {
         drag_handle.remove();
         stationary_handle.remove();
      };
   }, []);

   //Component did update.
   React.useEffect(() => {
   });

   //Close this tool.
   function close() {
      DrawerMenu.closeTool();
   }

   //Change events.
   function ownerChanged(event: React.ChangeEvent<HTMLInputElement>) {
      ownerText = event.target.value;
      refresh();
   }

   function ownerAddressChanged(event: React.ChangeEvent<HTMLInputElement>) {
      ownerAddressText = event.target.value;
      refresh();
   }

   function approvalDateChanged(event: React.ChangeEvent<HTMLInputElement>) {
      approvalDateText = event.target.value;
      refresh();
   }

   function oldStreetChanged(event: React.ChangeEvent<HTMLInputElement>) {
      oldStreetText = event.target.value;
      refresh();
   }

   function newStreetChanged(event: React.ChangeEvent<HTMLInputElement>) {
      newStreetText = event.target.value;
      refresh();
   }

   function thomasBrothersChanged(event: React.ChangeEvent<HTMLInputElement>) {
      thomasBrothersText = event.target.value;
      refresh();
   }

   function mapNoChanged(event: React.ChangeEvent<HTMLInputElement>) {
      mapNoText = event.target.value;
      refresh();
   }

   function projectNoChanged(event: React.ChangeEvent<HTMLInputElement>) {
      projectNoText = event.target.value;
      refresh();
   }

   function apnChanged(event: React.ChangeEvent<HTMLInputElement>) {
      apnText = event.target.value;
      refresh();
   }

   function mapScaleChanged(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
      scaleText = event.target.value;
      Util.logMsg("PrintAddressChangeUI.scaleText:", scaleText);
      setStandardScale();
      PrintAddressChangeMap.setPrintParameters();
      refresh();
   }

   //Set predefined scale per inch from dropdown list.
   function setStandardScale() {
      isStandardScale = false;

      if (scaleText !== Settings.print.scales[0]) {
         isStandardScale = true;
         const sa = scaleText.split("=");
         mapScaleFeetPerInch = Util.parseFlt(sa[1]);
         if (scaleText.Contains("ile")) {
            mapScaleFeetPerInch *= 5280;
         }
      }
   }

   //Print button click event.
   function handlePrint() {
      if (!PrintAddressChangeMap.busy) {

         if (!MainMap.activeView.stationary) {
            SnackBar.show("Wait until map is ready");
            return;
         }

         /*newWindow = window.open("", "_blank");*/ //May need to create the new window here to avoid the popup being blocked by the browser.
         //GraLay.temp.removeAll();
         //Print map step 1 of 4.
         setTimeout(function () { PrintAddressChangeMap.getMapURL(); }, 10); //Wait for yellow printing outline to be cleared.
      }
   }

   const scrollDivID: string = toolName.replace(" ", "_").replace(" ", "_") + "_Scroll";

   const styles: Default.iStyles = {
      formControlLabel: { margin: 0, padding: 0, paddingRight: 15 },
   };

   return (
      <Paper>
         <WidgetHeading.Render title={toolName} onClose={close} />

         <div id={scrollDivID} style={Default.styles.appToolDiv}>

            <TextField style={{ marginTop: 0 }}
               id="owner-text"
               label="Owner"
               defaultValue=""
               margin="dense"
               autoFocus={false}
               fullWidth
               onChange={ownerChanged}
               slotProps={{ htmlInput: { maxLength: 72 } }}
            />

            <TextField style={{ marginTop: 0 }}
               id="owner-address-text"
               label="Owner Address"
               defaultValue=""
               margin="dense"
               autoFocus={false}
               fullWidth
               onChange={ownerAddressChanged}
               slotProps={{ htmlInput: { maxLength: 72 } }}
            />

            <TextField style={{ marginTop: 0 }}
               id="approval-date-text"
               label="Approval Date"
               defaultValue=""
               margin="dense"
               autoFocus={false}
               fullWidth
               onChange={approvalDateChanged}
               slotProps={{ htmlInput: { maxLength: 20 } }}
            />

            <TextField style={{ marginTop: 0 }}
               id="old-street-text"
               label="Old Street Name/Address"
               defaultValue=""
               margin="dense"
               autoFocus={false}
               fullWidth
               onChange={oldStreetChanged}
               slotProps={{ htmlInput: { maxLength: 36 } }}
            />

            <TextField style={{ marginTop: 0 }}
               id="new-street-text"
               label="New Street Name/Address"
               defaultValue=""
               margin="dense"
               autoFocus={false}
               fullWidth
               onChange={newStreetChanged}
               slotProps={{ htmlInput: { maxLength: 180 } }}
            />

            <TextField style={{ marginTop: 0 }}
               id="thomas-brothers-text"
               label="Thomas Brothers"
               defaultValue=""
               margin="dense"
               autoFocus={false}
               fullWidth
               onChange={thomasBrothersChanged}
               slotProps={{ htmlInput: { maxLength: 36 } }}
            />

            <TextField style={{ marginTop: 0 }}
               id="map-no-text"
               label="Map No"
               defaultValue=""
               margin="dense"
               autoFocus={false}
               fullWidth
               onChange={mapNoChanged}
               slotProps={{ htmlInput: { maxLength: 36 } }}
            />

            <TextField style={{ marginTop: 0 }}
               id="project-no-text"
               label="Project No/Name"
               defaultValue=""
               margin="dense"
               autoFocus={false}
               fullWidth
               onChange={projectNoChanged}
               slotProps={{ htmlInput: { maxLength: 36 } }}
            />

            <TextField style={{ marginTop: 0 }}
               id="apn-text"
               label="APN"
               defaultValue=""
               margin="dense"
               autoFocus={false}
               fullWidth
               onChange={apnChanged}
               slotProps={{ htmlInput: { maxLength: 36 } }}
            />

            <TextField select style={{ marginRight: 60, marginTop: 15 }}
               label="Map Scale"
               title="Map Scales"
               slotProps={{
                  htmlInput: { id: "map-scales" },
                  inputLabel: { htmlFor: "map-scales" }
               }}
               value={scaleText}
               onChange={mapScaleChanged}
            >
               {Util_MUI.buildSelectMenuItems(Settings.print.scales)}
            </TextField>

            <div className="app-flex-row-around" style={{ marginTop: 10 }}>
               <Button variant="outlined" size="medium" color="primary" onClick={handlePrint} title="Print Map" aria-label="Print Map">
                  <Icon color="action">print</Icon>
                  <span style={{ marginLeft: 7 }}></span>
                  Print
               </Button>
            </div>

         </div>
      </Paper>

   ); //end return.
} //end function.
